import { DropdownOption } from '@urbanx/agx.ui-components2';
import { Agreements } from '@urbanx/agx.agencies.client';

export const qldAgreementOptions: DropdownOption[] = [
  {
    value: Agreements.QLDResidentialForm6.toString(),
    label: Agreements.QLDResidentialForm6,
  },
];
